import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { SatelliteScreenResolution, UpdateSatelliteScreen } from "../../../schemas/location";
import { queryKeys } from "../../query-keys";

export function useLocationScreens(resolution: SatelliteScreenResolution | "all" = "pending") {
	return useQuery({
		queryFn: () => adminApi.locations.screens.list(resolution),
		queryKey: queryKeys.locationScreens.list(resolution),
	});
}

export function useUpdateLocationScreen() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpdateSatelliteScreen }) =>
			adminApi.locations.screens.update(id, body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.locationScreens.all });
			queryClient.invalidateQueries({ queryKey: queryKeys.locations.all });
		},
	});
}

export function useRunLocationScreens() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (limit?: number) => adminApi.locations.screens.run(limit),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.locationScreens.all });
			queryClient.invalidateQueries({ queryKey: queryKeys.locations.all });
		},
	});
}
